import React from 'react';
import { Box } from '@mui/material';
import { FieldFrame } from './FormField';

interface SystemValueProps {
  id: string;
  label: string;
  /** What the system puts here, said in words: "Broj dana prisustva u mesecu". */
  children: React.ReactNode;
  /** 20px, in the primary colour. */
  icon: React.ReactElement<{ sx?: object }>;
  /** When and how the value is filled in: "Upisuje se sam pri generisanju računa." */
  hint?: React.ReactNode;
  wide?: boolean;
}

/**
 * A value the system fills in by itself, shown where a field would be.
 *
 * Not a disabled input: an empty disabled field reads as "nothing here" or "you may not",
 * when the truth is "this is worked out for you". So it is a tinted box with an icon and
 * the value in words - not focusable, since there is nothing to do in it, and read as one
 * group, "Količina: Broj dana prisustva u mesecu".
 */
const SystemValue: React.FC<SystemValueProps> = ({ id, label, children, icon, hint, wide }) => (
  <FieldFrame id={id} labelId={`${id}-label`} label={label} hint={hint} wide={wide}>
    <Box
      id={id}
      role="group"
      aria-labelledby={`${id}-label ${id}-value`}
      aria-describedby={hint ? `${id}-message` : undefined}
      sx={{
        height: 44,
        borderRadius: '10px',
        bgcolor: 'surface.tint',
        px: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: 15,
        color: 'text.primary'
      }}
    >
      {React.cloneElement(icon, { 'aria-hidden': true, sx: { fontSize: 20, color: 'primary.main', flexShrink: 0 } } as object)}
      <span id={`${id}-value`}>{children}</span>
    </Box>
  </FieldFrame>
);

export default SystemValue;
